import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityDataServiceBase } from "@shared-base/entity-data-service.base";
import { UrlQueryDef } from "@shared-base/url-query-definition.base";
import { TranslateService } from "@shared-services/translate.service";
import { Tools } from "@shared-utils/tools.util";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PackageDealsDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient,
    protected translateService: TranslateService)
  {
    super(http, 'packageDeals');
  }

  public getBundle(): Observable<any>
  {
    const queryDef = new UrlQueryDef();

    queryDef.params = {
      language: this.translateService.languageCode,
      offset: Tools.getOffset()
    };

    const subject = this.http.get(this.createUrl(""), queryDef.getRequestConfig());

    return subject;
  }
}
